<app-list-table-filters-wrapper
  [title]="'Recommendations for farmers'"
  [backButton]="true"
  [parentRoute]="'/crop-monitoring'"
  [columns]="tableColumns"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [filtersForms]="filtersForms"
  [(filterModel)]="filterModel"
  [filtersParams]="filtersParams"
  [toggleFilter]="toggleFilter"
  [defaultParams]="defaultParams"
  [storageKey]="null"
  [isLoading]="loading"
  (applyFilters)="applyFilters()"
  (clearFilters)="clearFilters()"
>
</app-list-table-filters-wrapper>

<ng-template #regionTemplate let-row>
  <app-region-display [regionId]="regionId(row)" />
</ng-template>

<ng-template #fieldTemplate let-row>
  <app-field-passport-link [fieldId]="fieldId(row)" [fieldName]="fieldName(row)" />
</ng-template>

<ng-template #cropTemplate let-row>
  {{ cropLabel(cropId(row)) }}
</ng-template>

<ng-template #sourceTemplate let-row>
  @if (isSatelliteRow(row)) {
    {{ 'FARMER_RECOMMENDATIONS_SOURCE_SATELLITE' | translate }}
  } @else {
    {{ 'FARMER_RECOMMENDATIONS_SOURCE_GROUND' | translate }}
  }
</ng-template>

<ng-template #anomalyCellTemplate let-row>
  <div class="anomaly-cell">
    @if (isSatelliteRow(row)) {     
      <div class="anomaly-cell__line anomaly-cell__line--primary">
        {{ satelliteTypeLabel(satelliteAnomalyType(row)) || '' | translate }}
      </div>
      <div class="anomaly-cell__line">
        {{ 'CONDUCT_GROUND_SURVEY' | translate }}
      </div>
      @if (anomalyDescriptionLine(row); as desc) {
        <div class="anomaly-cell__line anomaly-cell__line--muted">
          {{ desc }}
        </div>
      }
    } @else {      
      <div class="anomaly-cell__line anomaly-cell__line--primary">
        {{ anomalyTypeLine(row) || '' }}
      </div>
      @if (anomalyDescriptionLine(row); as desc) {
        <div class="anomaly-cell__line anomaly-cell__line--muted">
          {{ desc }}
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #downloadTemplate let-row>
  @if (reportIdIfDownloadable(row); as rid) {
    <app-report-download-action [reportId]="rid" />
  } @else {
    <span>—</span>
  }
</ng-template>
